import { GraphQLClient as GraphQLRequestClient } from 'graphql-request';
import { getSdk } from './sdk';
class GraphQLClient {
    #sdk;
    #sdkWrapper = async (action) => {
        try {
            return action();
        }
        catch (error) {
            error.context = {
                isGraphQlError: true,
            };
            throw error;
        }
    };
    get sdk() {
        return this.#sdk;
    }
    init(graphQlDomain, headers) {
        const client = new GraphQLRequestClient(`${graphQlDomain}/query`, {
            headers,
        });
        this.#sdk = getSdk(client, this.#sdkWrapper);
    }
}
export const graphQlClient = new GraphQLClient();
